const FullScreenIcon = ({ ...props }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.5 10C4.22386 10 4 9.77614 4 9.5V5.5V4.5C4 4.22386 4.22386 4 4.5 4H5.5H9.5C9.77614 4 10 4.22386 10 4.5V5.5C10 5.77614 9.77614 6 9.5 6H6L6 9.5C6 9.77614 5.77614 10 5.5 10H4.5ZM14.5 4C14.2239 4 14 4.22386 14 4.5V5.5C14 5.77614 14.2239 6 14.5 6H18V9.5C18 9.77614 18.2239 10 18.5 10H19.5C19.7761 10 20 9.77614 20 9.5V5.5V4.5C20 4.22386 19.7761 4 19.5 4H18.5H14.5ZM19.5 14C19.7761 14 20 14.2239 20 14.5V18.5V19.5C20 19.7761 19.7761 20 19.5 20H18.5H18.4996L14.5 20C14.2239 20 14 19.7761 14 19.5V18.5C14 18.2239 14.2239 18 14.5 18L18 18V14.5C18 14.2239 18.2239 14 18.5 14H19.5ZM10 19.5C10 19.7761 9.77614 20 9.5 20L5.50088 20C5.50059 20 5.50029 20 5.5 20L4.5 20C4.22386 20 4 19.7761 4 19.5V18.5V14.5C4 14.2239 4.22386 14 4.5 14H5.5C5.77614 14 6 14.2239 6 14.5L6 18L9.5 18C9.77614 18 10 18.2239 10 18.5V19.5Z"
			fill="currentColor"
		/>
	</svg>
)

export default FullScreenIcon
